import { render, staticRenderFns } from "./ServiceResultCard.vue?vue&type=template&id=53231a12&"
import script from "./ServiceResultCard.vue?vue&type=script&lang=js&"
export * from "./ServiceResultCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports